import { formatDateUTC } from "@/utils/utils";

export default {
    data(): any {
        return {};
    },

    methods: {
        isStrEmpty(str: string): boolean {
            return !str || str.length === 0;
        },

        isArrayEmpty(arr: any[]): boolean {
            return !arr || arr.length === 0 || !Array.isArray(arr);
        },

        isObjEmpty(obj: any[]): boolean {
            return !obj || Object.keys(obj).length === 0;
        },

        getParamQueryTheme(key: string): string {
            const search = window.location.search;
            const params = new URLSearchParams(search);
            const account = params.get(key) || "";
            return account;
        },

        compareVersions(version1: string, version2: string): string {
            const version1Parts: number[] = version1.split(".").map(Number);
            const version2Parts: number[] = version2.split(".").map(Number);

            if (
                version1Parts.slice(0, 2).join(".") !==
                version2Parts.slice(0, 2).join(".")
            ) {
                return version1;
            } else {
                return version2;
            }
        },

        formatPrice(number: number, decimal = 2): string {
            const formatter = new Intl.NumberFormat("en-US", {
                minimumFractionDigits: decimal,
                maximumFractionDigits: decimal,
            });
            return formatter.format(number);
        },

        renderDate(date: string | Date) {
            const dateFormat = formatDateUTC(date, 2);

            return `${dateFormat.day}/${dateFormat.month}/${dateFormat.year} ${dateFormat.hour}:${dateFormat.minutes}`;
        },
    },
};
